<template>
    <div class="mask">
        <div class="confirm-container">
            <div class="content">
                <div class="text">{{ message }}</div>
            </div>
            <div class="control">
                <!-- <div
                    class="cancel"
                    :class="{'strong': strongButton === 'cancel'}"
                    @click="onCancel"
                >{{ cancelText }}</div> -->
                <div
                    class="confirm"
                    :class="{'strong': strongButton === 'confirm'}"
                    @click="onConfirm"
                >{{ confirmText }}</div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'ConfirmModal',
    props: {
        cancelText: {
            type: String,
            default: '取消'
        },
        confirmText: {
            type: String,
            default: '重试'
        },
        message: {
            type: String,
            default: '查询优惠券信息失败'
        },
        strongButton: {
            type: String,
            default: 'confirm'
        }
    },
    methods: {
        onCancel() {
            console.log('cancel');
            this.$emit('onCancel');
        },
        onConfirm() {
            this.$emit('onConfirm');
        }
    }
};
</script>

<style lang="scss" scoped>
.mask{
    width:100vw;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    background:rgba(0,0,0,.68);
    z-index:2;
}
    .confirm-container {
        position:absolute;
        z-index:3;
        top:calc(50vh - 60px);
        left:calc(50% - 117px);
        width: 235px;
        height: 121.5px;
        background: #ffffff;
        border-radius: 12px;
    }
    .content {
        height: 81px;
        width: 100%;
        display: flex;
        align-content: flex-end;
        justify-content: center;
        border-bottom: 0.5px solid #eaeaea;
        .text {
            width: 205.5px;
            height: 41px;
            margin-top: 20px;
            font-size: 14px;
            color: #333333;
            text-align: center;
            padding: 0 28px;
            box-sizing: border-box;
        }
    }
    .control {
        height: 40px;
        display: inline-flex;
        width: 100%;
        justify-content: center;
        .cancel {
            line-height: 40px;
            width: 50%;
            font-size: 16px;
            color: #999999;
            text-align: center;
            border-right: 0.5px solid #eaeaea;
            &.strong {
                color: #FF6352;
            }
        }
        .confirm {
            line-height: 40px;
            width: 50%;
            font-size: 16px;
            color: #999999;
            text-align: center;
            &.strong {
                color: #FF6352;
            }
        }

    }
</style>